import React from 'react';

import LinkIconButton from '@atlaskit/button/icon/link';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';

type MyRouterLinkConfig = {
	to: string;
	replace?: boolean;
};

const LinkIconButtonWithRoutingExample = (): React.JSX.Element => {
	return (
		<LinkIconButton<MyRouterLinkConfig>
			href={{
				to: '/profile',
				replace: true,
			}}
			icon={PersonAvatarIcon}
			label="View profile"
		/>
	);
};

export default LinkIconButtonWithRoutingExample;
